import { useQueryParameter } from '@/context/QueryParameter';
import { useCallback, useLayoutEffect, useRef, useState } from 'react';

type TViewAdminInvoiceReportDetailProps = () => {
  selectedId: string;
  onDrawerOpen: (id: string) => void;
  onDrawerClose: () => void;
  selectedIndex: number | undefined;
  setSelectedIndex: (index: number | undefined) => void;
};

export const useViewAdminInvoiceReportDetail: TViewAdminInvoiceReportDetailProps =
  () => {
    const [param, setParam] = useQueryParameter();
    const [selectedIndex, setSelectedIndex] = useState<number | undefined>(
      undefined
    );

    /**
     * Store the latest param in a ref to avoid stale closures.
     * useLayoutEffect runs synchronously after DOM updates but before browser paint,
     * ensuring the ref is updated before any effects that might call onDrawerOpen.
     */
    const paramRef = useRef(param);
    useLayoutEffect(() => {
      paramRef.current = param;
    });

    const selectedId = param.get('id') || '';

    const onDrawerOpen = useCallback(
      (id: string) => {
        if (id) {
          const next = new URLSearchParams(paramRef.current);
          next.set('id', id);
          setParam(next, { replace: true });
        }
      },
      [setParam]
    );

    const onDrawerClose = useCallback(() => {
      const next = new URLSearchParams(paramRef.current);
      next.delete('id');
      setParam(next, { replace: true });
    }, [setParam]);

    return {
      selectedId,
      onDrawerOpen,
      onDrawerClose,
      selectedIndex,
      setSelectedIndex,
    };
  };
